import Error from '../model/Error';
import ResponseParser from '../parser/ResponseParser.js';
import axios from 'axios';

export default class ClubInvoiceChargebackPdfRepository {

    static createDownloadHistory(clubInvoiceId) {
        return new Promise((resolve, reject) => {
            axios
                .post(`/club/club-invoice-chargeback-pdfs/${clubInvoiceId}/download-history`)
                .then(response => resolve(response))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static bulkCreateDownloadHistory(clubId, clubInvoiceIds, collected) {
        const data = { invoices: clubInvoiceIds, collected: collected };
        return new Promise((resolve, reject) => {
            axios
                .post(`/club/clubs/${clubId}/club-invoice-chargeback-pdfs/download-history`, data)
                .then(response => resolve(response))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static createEmailHistory(clubInvoiceId) {
        return new Promise((resolve, reject) => {
            axios
                .post(`/club/club-invoice-chargeback-pdfs/${clubInvoiceId}/email-history`)
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static bulkCreateEmailHistory(clubId, clubInvoiceIds) {
        const data = { invoices: clubInvoiceIds };
        return new Promise((resolve, reject) => {
            axios
                .post(`/club/clubs/${clubId}/club-invoice-chargeback-pdfs/email-history`, data)
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static downloadChargebackPdf(url) {
        return new Promise((resolve, reject) => {
            axios.get(url, { responseType: 'blob' })
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', new ResponseParser().getFilenameFromHeaders(response.headers));
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    resolve();
                })
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }
}
